import React from "react";
import ToolMenuIconButton from "../../common/ToolMenuIconButton";
import { BsArrowLeft } from "react-icons/bs";

export interface IProps {
  onClick?: () => void;
}

class BackButton extends React.Component<IProps> {
  render(): JSX.Element {
    return (
      <ToolMenuIconButton
        icon={<BsArrowLeft />}
        tooltip="Back"
        onClick={this.props.onClick}
      />
    );
  }
}

export default BackButton;
